import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { mutationHandler } from "../mutationHandler.ts"
import { UserLabels } from "../../backend/types/userLabels.ts"

export type LabelData = {
    id: string,
    value: string[]
}

export const useGetUserLabels = (enabled: boolean) => useQuery<UserLabels>({
    queryKey: [`labels`],
    enabled
})

const updateUserLabel = (labelData: LabelData) =>
    fetch(`/api/labels`, {
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(labelData)
    })

export const useUpdateUserLabel = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (labelData: LabelData) =>
            mutationHandler<UserLabels>(updateUserLabel(labelData)),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`labels`] })
        },
    })
}
